module.exports = __webpack_public_path__ + "img/Icone_48.fe6ff1ba.png";